enum UserInfo {
  GET_RECENT_PROPERTY_REQUEST = 'client/getRecentPropertyRequest',
  GET_RECENT_PROPERTY_FULFILLED = 'client/getRecentPropertyFulfilled',
  GET_RECENT_PROPERTY_REJECTED = 'client/getRecentPropertyRejected',
  CLEAR_RECENT_PROPERTY = 'client/clearRecentProperty',
}

export default UserInfo;
